// test1066
(1066 && 0);
